import styled from 'styled-components';

import { SMALL_DEVICE_HEIGHT } from '@kiosk/constants';

export const FormFieldsContainer = styled.div<{ deviceHeight: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-height: ${SMALL_DEVICE_HEIGHT}px) {
    overflow: visible;
  }

  @media (min-height: ${SMALL_DEVICE_HEIGHT + 1}px) {
    margin-top: 40px;
    max-height: ${props => props.deviceHeight * 0.5}px;
    overflow-x: hidden;
  }
`;
